/// <reference types="google.maps" />
import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

type MarkerData = {
  lat: number;
  lon: number;
  title: string;
  icon?: string;
};

export default class extends Controller {
  async connect() {
    console.log('initMapForm');

    const apiKey = $('meta[name="google-maps-api-key"]').attr('content');
    setOptions({ key: apiKey });
    await importLibrary("maps");
    await importLibrary("marker");

    const mark = $("#toJs").data("marker") as MarkerData;
    const map = new google.maps.Map(
      document.getElementById("map") as HTMLElement,
      {
        center: {
          lat: mark.lat,
          lng: mark.lon,
        },
        zoom: 17,
        draggableCursor: "default",
        gestureHandling: "greedy",
        mapId: 'MyMapId'
      }
    );

    const container = document.createElement("div");
    container.appendChild(new google.maps.marker.PinElement());
    const label = document.createElement("div");
    label.classList.add('map-labels');
    label.innerText = mark.title;
    container.appendChild(label);
    const marker = new google.maps.marker.AdvancedMarkerElement({
      position: { lat: mark.lat, lng: mark.lon },
      map: map,
      title: mark.title,
      content: container
    });
    google.maps.event.addListener(map, 'click', function (event: any) {
      $('.address_lat').val(event.latLng.lat());
      $('.address_lon').val(event.latLng.lng());
      marker.position = event.latLng;
    });
    $('.address_lat').on('change', function () {
      marker.position!.lat = parseFloat($(this).val() as string);
      map.setCenter(marker.position!);
    });
    $('.address_lon').on('change', function () {
      marker.position!.lng = parseFloat($(this).val() as string);
      map.setCenter(marker.position!);
    });

    const geocoder = new google.maps.Geocoder();
    $('.address').on('change', function () {
      geocodeAddress(geocoder, $(this).val() as string);
    });
    if (mark.lat == 47.500855 && mark.lon == 19.053794) {
      if ($('.address').val() && ($('.address').val() as string).length > 0) {
        geocodeAddress(geocoder, $('.address').val() as string);
      }
    }

    function geocodeAddress(geocoder: google.maps.Geocoder, address: string | null) {
      if (!address) return;
      geocoder.geocode({
        'address': address
      }, function (results, status) {
        if (status === 'OK' && results) {
          marker.position = results[0].geometry.location;
          map.setCenter(marker.position);
          $('.address_lat').val(results[0].geometry.location.lat());
          $('.address_lon').val(results[0].geometry.location.lng());
        } else {
          alert('Nem sikerült a címet felismerni!');
        }
      });
    }
  }
}